import React from 'react';
import Skeleton from '../ui/Skeleton';

/**
 * Loading skeleton for the Role Management page
 */
function RoleSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <Skeleton width="200px" height="2rem" />
        <Skeleton width="180px" height="2.5rem" className="rounded-md" />
      </div>
      
      {/* Search skeleton */}
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-6">
          <Skeleton width="100%" height="2.5rem" className="rounded-md" />
        </div>
        
        {/* Table skeleton */}
        <Skeleton.Table rows={5} columns={5} />
      </div>
    </div>
  );
}

/**
 * Loading skeleton for the role detail modal
 */
RoleSkeleton.Modal = function RoleModalSkeleton() {
  return (
    <div className="space-y-4">
      <div>
        <Skeleton width="100px" height="1rem" className="mb-1" />
        <Skeleton width="100%" height="2.5rem" className="rounded-md" />
      </div>
      
      <div>
        <Skeleton width="120px" height="1rem" className="mb-1" />
        <Skeleton width="100%" height="6rem" className="rounded-md" />
      </div>
      
      <div>
        <Skeleton width="140px" height="1rem" className="mb-1" />
        <div className="border rounded-md p-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {Array.from({ length: 12 }).map((_, index) => (
              <div key={index} className="flex items-center gap-2">
                <Skeleton width="1rem" height="1rem" className="rounded-sm" />
                <Skeleton width="80%" height="1rem" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Loading skeleton for the permission matrix
 */
RoleSkeleton.PermissionMatrix = function PermissionMatrixSkeleton() {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="w-1/4 px-4 py-2 text-left">
              <Skeleton width="80%" height="1.5rem" />
            </th>
            {Array.from({ length: 3 }).map((_, index) => (
              <th key={index} className="px-2 py-2 text-center">
                <Skeleton width="80%" height="1.5rem" className="mx-auto" />
                <Skeleton width="90%" height="1rem" className="mt-1 mx-auto" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 8 }).map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b">
              <td className="px-4 py-3">
                <Skeleton width="90%" height="1.25rem" />
              </td>
              {Array.from({ length: 3 }).map((_, colIndex) => (
                <td key={colIndex} className="px-2 py-2 text-center">
                  <div className="border rounded-md p-2 mx-auto">
                    <Skeleton width="100%" height="1.5rem" className="rounded-md" />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RoleSkeleton;